import React from "react";

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>;

export function PageTitle(props: Props) {
    return <h1 {...props} />;
}
